import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

const QRCodePage = () => {
  const qrRef = useRef(null);

  const pdfUrl = "https://bobsrecipe.appxes.com/Recipe.pdf"; // change IP

  const downloadQR = () => {
    const canvas = qrRef.current.querySelector("canvas");

    // Create high resolution canvas
    const scale = 4; // increase for more quality (4x)
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = canvas.width * scale;
    tempCanvas.height = canvas.height * scale;

    const ctx = tempCanvas.getContext("2d");

    // Smooth scaling off for sharp edges
    ctx.imageSmoothingEnabled = false;

    ctx.drawImage(canvas, 0, 0, tempCanvas.width, tempCanvas.height);

    const image = tempCanvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = image;
    link.download = "qr-print.png";
    link.click();
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Print Ready QR Code</h1>

      <div ref={qrRef}>
        <QRCodeCanvas
          value={pdfUrl}
          size={500}              // bigger base size
          level="H"               // high error correction
          includeMargin={true}    // white border
        />
      </div>

      <p>High quality QR for printing</p>

      <button onClick={downloadQR}>
        Download Print QR
      </button>
    </div>
  );
};

export default QRCodePage;